<template>
  <v-container>
    <v-row v-if="showScanner">
      <v-col cols="12" class="d-flex align-center justify-center">
        <h1>Check In</h1>
      </v-col>
      <v-col cols="12" class="d-flex align-center justify-center">
        <p>Scan your QR code to check into this training!</p>
      </v-col>
    </v-row>
    <v-row v-if="showSuccessMsg">
      <v-col cols="12" class="d-flex align-center justify-center">
        <v-alert type="success" dismissible>
          {{ successMsg }}
        </v-alert>
      </v-col>
    </v-row>
    
    <p class="decode-result">Last result: <b>{{ result }}</b></p>
    <p class="error">{{ error }}</p>
    <qrcode-stream @decode="onDecode" @init="onInit" />
  
  </v-container>
</template>

<script>
  import { QrcodeStream } from 'vue-qrcode-reader'
  
  export default {
    name: 'ScanCheckIn',
    components: { 
      QrcodeStream 
    },
    data () {
      return {
        result: '',
        error: 'no error',
        showSuccessMsg: false,
        successMsg: ''
      }
    },
    computed: {
      showScanner () {
        return this.sessions.length > 0 && this.employees.length > 0
      },
      sessions () {
        return this.$store.getters.getSessions
      },
      employees () {
        return this.$store.getters.getEmployees
      }
    },
    created () {
      this.getCameraPermission()
      this.$store.dispatch('getRecords', {
        table: 'Sessions',
        view: 'All Sessions',
        dispatch: 'setSessions'
      })
      this.$store.dispatch('getRecords', {
        table: 'Employees',
        view: 'All Employees',
        dispatch: 'setEmployees'
      })
    },
    methods: {
      onDecode (result) {
        console.log('decoded', result)
        this.result = result
        
        const code = JSON.parse(result)
        const { sessionId, employeeId } = code
        const employee = this.employees.find(e => {
          return e.id === employeeId
        })
        const session = this.sessions.find(s => {
          return s.id === sessionId
        })
        const checkedInAttendees = session.fields['Checked In'] ? 
                                   session.fields['Checked In'] : []
        if (checkedInAttendees.includes(employeeId)) {
          this.popSuccessMsg(`${employee.fields.Name} has already checked in!`)
        }
        checkedInAttendees.push(employeeId)
        this.$store.dispatch('updateRecords', {
          table: 'Sessions',
          records: [{
            id: sessionId,
            fields: {
              'Checked In': checkedInAttendees
            }
          }]
        })
        .then(response => {
          console.log('got resp', response)
          this.popSuccessMsg(`Checked In ${employee.fields.Name}!`)
        })
        .catch(err => {
          console.log('got err', err)
        })
      },
      popSuccessMsg (msg) {
        this.successMsg = msg
        this.showSuccessMsg = true
      },
      async onInit (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.error = "ERROR: you need to grant camera access permisson"
          } else if (error.name === 'NotFoundError') {
            this.error = "ERROR: no camera on this device"
          } else if (error.name === 'NotSupportedError') {
            this.error = "ERROR: secure context required (HTTPS, localhost)"
          } else if (error.name === 'NotReadableError') {
            this.error = "ERROR: is the camera already in use?"
          } else if (error.name === 'OverconstrainedError') {
            this.error = "ERROR: installed cameras are not suitable"
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.error = "ERROR: Stream API is not supported in this browser"
          }
        }
      },
      getCameraPermission () {
        navigator.getUserMedia({ 
          audio: false, 
          video: { 
            facingMode: { 
              exact: 'environment' 
            } 
          } 
        }, () => {
          // got permission to use camera
        }, (err) => {
          this.error = err
        })
      }
    }
  }
</script>
